import { createAction } from '@reduxjs/toolkit';

const prefix = `knowledge/smartConversationResponse`;

export const knowledgeActions = {
  smartConversationResponseReceived: createAction<{ message: string }>(
    `${prefix}/received`,
  ),
  smartConversationResponseRequested: createAction(`${prefix}/requested`),
  smartConversationResponseError: createAction<{ errorMessage: string }>(
    `${prefix}/error`,
  ),
  smartConversationResponseFinally: createAction(`${prefix}/finally`),
};
